import { useMemo, useState } from 'react'
import { getPeriodoMesAtual, parseToMysqlFormat } from '../../../../services/util/date.service'
import { getProdutos } from '../../../../services/api/https/registration/produto.http'
import EstoqueHttp from '../../../../services/api/https/estoque/Estoque.http'
import ExcelJS from 'exceljs'
import { errorHandler } from '../../../../services/util/error.service'

export const LOADING_MESSAGE = {
  NONE: 0,
  LOADING_PRODUCTS: 1,
  LOADING_EXTRATO_XLSX: 2,
  LOADING_EXTRATO_PDF: 3,
}
export const EXTRATO_XLSX = 'Extrato - XLXS'
export const EXTRATO_PDF = 'Extrato - PDF'

const InitalState = {
  listaProdutos: [],
  periodo: getPeriodoMesAtual(),
  selectedCompany: null,
  globalFilter: '',
  errorMessage: null,
  loadingMessage: LOADING_MESSAGE.NONE,
  selectedProduto: null,
}

export default function useExtratoMovimentacaoPorProduto() {
  const [state, setState] = useState({ ...InitalState })

  const localDispatch = useMemo(() => {
    return {
      resetState() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
        }))
      },
      onPesquisar: (pInicial, pFinal, selectedCompany) => {
        if (!selectedCompany) {
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione a Empresa' }))
        }
      },
      onCompanyChange: (value, selectedTP) => {
        if (!selectedTP) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione o Operador Logístico',
          }))
        } else {
          setState(prevState => ({
            ...prevState,
            selectedCompany: value,
            loadingMessage: LOADING_MESSAGE.LOADING_PRODUCTS,
          }))
        }
      },
      onDataTableSearchChange: value => {
        setState(prevState => ({
          ...prevState,
          globalFilter: value,
        }))
      },
      onDateChange: (dataInicial, dataFinal) => {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial, dataFinal },
        }))
      },
      onMenuItemClicked: (item, product) => {
        switch (item) {
          case EXTRATO_XLSX:
            setState(prevState => ({
              ...prevState,
              errorMessage: null,
              loadingMessage: LOADING_MESSAGE.LOADING_EXTRATO_XLSX,
              selectedProduto: product,
            }))
            break
          case EXTRATO_PDF:
            setState(prevState => ({
              ...prevState,
              errorMessage: null,
              loadingMessage: LOADING_MESSAGE.LOADING_EXTRATO_PDF,
              selectedProduto: product,
            }))
            break
          default:
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Item no Menu NÃO implementado',
              loadingMessage: LOADING_MESSAGE.NONE,
              selectedProduto: null,
            }))
            break
        }
      },
      // API Fetches
      getProducts: async company => {
        try {
          const result = await getProdutos(company.id)
          setState(prevState => ({
            ...prevState,
            errorMessage: null,
            loadingMessage: LOADING_MESSAGE.NONE,
            listaProdutos: result.produtos,
          }))
        } catch (e) {
          setState(prevState => ({
            ...prevState,
            errorMessage: e,
            loadingMessage: LOADING_MESSAGE.NONE,
          }))
        }
      },
      getExtrato: async (tipoExtrato, product, dataInicial, dataFinal, selectedTp) => {
        const withTimeout = (p, ms = 20000) =>
          Promise.race([
            p,
            new Promise((_, rej) => setTimeout(() => rej(new Error('TIMEOUT')), ms)),
          ])
        try {
          switch (tipoExtrato) {
            case LOADING_MESSAGE.LOADING_EXTRATO_XLSX:
              const response = await withTimeout(
                EstoqueHttp.getExtratoMovimentacaoProdutoEmExcelUrl(
                  selectedTp,
                  product.id,
                  parseToMysqlFormat(dataInicial),
                  parseToMysqlFormat(dataFinal),
                ),
              )
              await gerarExcel(response)
              break
            case LOADING_MESSAGE.LOADING_EXTRATO_PDF:
              console.log('NOT IMPLEMENTED YET:', product)
              break
            default:
              setState(prevState => ({
                ...prevState,
                errorMessage: 'Tipo de Extrato NÃO implementado',
              }))
              break
          }
        } catch (e) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(e),
          }))
        } finally {
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOADING_MESSAGE.NONE,
            selectedProduto: null,
          }))
        }
      },
    }
  })

  return { state, localDispatch }
}

function formatDateTime(value) {
  if (!value) return ''
  const d = new Date(value)
  const pad = n => String(n).padStart(2, '0')
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

async function gerarExcel({ data_inicial, data_final, product, saldo_inicial, movimentacoes }) {
  if (!movimentacoes.length) {
    throw new Error('Não existe movimentação deste produto')
  }
  const { product_code, name: produtct_name } = product

  const workbook = new ExcelJS.Workbook()
  const sheet = workbook.addWorksheet(`extrato`)

  // Título mesclado
  sheet.mergeCells('A1:I1')
  sheet.getCell('A1').value = 'Extrato de Movimentação de Estoque por Produto'
  sheet.getCell('A1').font = { bold: true, size: 14 }
  sheet.getCell('A1').alignment = { horizontal: 'left' }

  // Período
  sheet.getCell('A3').value = 'Período'
  sheet.getCell('A3').font = { bold: true }
  sheet.getCell('B3').value = new Date(data_inicial)
  sheet.getCell('B3').alignment = { horizontal: 'center' }
  sheet.getCell('C3').value = 'à'
  sheet.getCell('C3').alignment = { horizontal: 'center' }
  sheet.getCell('C3').font = { bold: true }
  sheet.getCell('D3').value = new Date(data_final)
  sheet.getCell('D3').alignment = { horizontal: 'center' }

  // Produto
  sheet.getCell('A5').value = 'Produto:'
  sheet.getCell('A5').font = { bold: true }
  sheet.mergeCells('B5:G5')
  sheet.getCell('B5').value = `${product_code} - ${produtct_name}`
  sheet.getCell('H5').value = 'Saldo Inicial'
  sheet.getCell('H5').font = { bold: true }
  sheet.getCell('I5').value = saldo_inicial
  sheet.getCell('I5').alignment = { horizontal: 'center' }

  sheet.addRow([]) // Add empty ROW

  // Cabeçalho
  const headerValues = [
    'Data Mov.',
    'Usuário',
    'Operação',
    'Grupo',
    'Lote',
    'Data Validade',
    'TAG Pallet',
    'Entrada',
    'Saída',
    'Saldo Final',
  ]
  const headerRow = sheet.addRow(headerValues)

  headerRow.eachCell(cell => {
    cell.font = { bold: true }
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }
    cell.alignment = { horizontal: 'center' }
  })

  // Dados
  const dados = []

  movimentacoes.forEach(m => {
    saldo_inicial += m.qte_entrada + m.qte_saida
    dados.push([
      formatDateTime(m.data_movimentacao),
      m.usuario ? m.usuario : '',
      m.operacao_estoque,
      m.grupo_de_operacao,
      m.lote ? m.lote : '',
      m.data_validade ? new Date(m.data_validade) : '',
      m.tag_pallet ? m.tag_pallet : '',
      m.qte_entrada,
      m.qte_saida,
      saldo_inicial,
    ])
  })
  dados.forEach(d => {
    const row = sheet.addRow(d)
    const aligmentCenterColumns = [1, 2, 5, 6, 7, 8, 9]
    row.eachCell((cell, colNumber) => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      }
      if (aligmentCenterColumns.includes(colNumber)) {
        cell.alignment = { horizontal: 'center' }
      }
    })
  })

  // Ajustando a largura das Colunas
  sheet.getColumn('A').width = 22 // Data Mov
  sheet.getColumn('B').width = 20 // Operacao
  sheet.getColumn('C').width = 20 // Grupo
  sheet.getColumn('D').width = 20 // Lote
  sheet.getColumn('E').width = 20 // Data Validade
  sheet.getColumn('F').width = 20 // Entrada
  sheet.getColumn('G').width = 20 // Saida
  sheet.getColumn('H').width = 20 // Saldo Final
  sheet.getColumn('I').width = 20 // Saldo Final

  // Gerar arquivo Excel em memória (como ArrayBuffer)
  const buffer = await workbook.xlsx.writeBuffer()

  // Criar blob e simular o download
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `extrato_produto_${product_code}.xlsx`
  a.click()
  window.URL.revokeObjectURL(url)
}
